import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { PermissionGuard } from 'app/core/permissions/permissions.guard';
import { TabbedPageLayoutComponent } from 'app/layout/page-layouts/tabbed/tabbed-page-layout.component';

export const casinoRoutes: Route[] = [
    {
        path: 'casino',
        canActivate: [AuthGuard],
        component: LayoutComponent,
        children: [
            {
                path: '',
                redirectTo: 'games',
                pathMatch: 'full',
            },
            {
                path: 'games',
                canActivate: [PermissionGuard],
                data: {
                    permission: 'READ_CASINO_GAME',
                    breadcrumbs: [
                        { label: 'navigation.casino.title', link: '/casino' },
                        { label: 'navigation.casino.games' },
                    ],
                    actions: [
                        {
                            label: '',
                            icon: 'heroicons_outline:cog-6-tooth',
                            execute: (componentInstance) => {
                                componentInstance.openTableColumnSettings();
                            },
                        },
                        {
                            label: 'actions.export',
                            icon: 'heroicons_outline:document-arrow-down',
                            execute: (componentInstance) => {
                                componentInstance.exportTableData();
                            },
                        },
                    ],
                },
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import(
                                './pages/games/casino-games-list.component'
                            ).then((c) => c.CasinoGamesListComponent),
                    },
                ],
            },
            // Placeholder routes for future implementation
            {
                path: 'categories',
                canActivate: [PermissionGuard],
                data: {
                    permission: 'READ_CASINO_CATEGORY',
                    breadcrumbs: [
                        { label: 'navigation.casino.title', link: '/casino' },
                        { label: 'navigation.casino.categories' },
                    ],
                },
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import(
                                './pages/categories/casino-categories-list.component'
                            ).then((c) => c.CasinoCategoriesListComponent),
                    },
                ],
            },
            {
                path: 'categories/:categoryId/games',
                canActivate: [PermissionGuard],
                data: {
                    permission: 'UPDATE_CASINO_CATEGORY',
                    breadcrumbs: [
                        { label: 'navigation.casino.title', link: '/casino' },
                        { label: 'navigation.casino.categories', link: '/casino/categories' },
                        { label: 'casino.categories.games.breadcrumb' },
                    ],
                },
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import(
                                './pages/category-games/category-games.component'
                            ).then((c) => c.CategoryGamesComponent),
                    },
                ],
            },
            {
                path: 'providers',
                canActivate: [PermissionGuard],
                data: {
                    permission: 'READ_CASINO_PROVIDER',
                    breadcrumbs: [
                        { label: 'navigation.casino.title', link: '/casino' },
                        { label: 'navigation.casino.providers' },
                    ],
                },
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import(
                                './pages/providers/casino-providers-list.component'
                            ).then((c) => c.CasinoProvidersListComponent),
                    },
                ],
            },
            {
                path: 'logs',
                canActivate: [PermissionGuard],
                data: {
                    permission: 'READ_CASINO_AUDIT_LOG',
                    breadcrumbs: [
                        { label: 'navigation.casino.title', link: '/casino' },
                        { label: 'navigation.casino.auditLogs' },
                    ],
                },
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import(
                                './pages/audit-logs/casino-audit-logs-list.component'
                            ).then((c) => c.CasinoAuditLogsListComponent),
                    },
                ],
            },
        ],
    },
];
